import { useState } from 'react'
import { initiateForgotPassword, submitNewPassword } from '../../../../api/auth'
import { useToast } from '../../../ui'

const emailRegex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/

export const useRecoverPassword = (setRecoverPasswordStep, backToLogin) => {
    const toast = useToast()
    const [email, setEmail] = useState('')
    const [emailError, setEmailError] = useState('')
    const [newPassword, setNewPassword] = useState({
        code: '',
        password: '',
        confirmPassword: '',
    })

    const handleEmailChange = (value) => {
        setEmail(value)

        // Validate email format in real-time
        if (value && !emailRegex.test(value)) {
            setEmailError('Please enter a valid email address')
        } else {
            setEmailError('')
        }
    }

    const validateEmail = () => {
        if (!email) {
            setEmailError('Please enter your email address')
            return false
        }
        if (!emailRegex.test(email)) {
            setEmailError('Please enter a valid email address')
            return false
        }
        setEmailError('')
        return true
    }

    const checkEqualPasswords = () => {
        return newPassword.password === newPassword.confirmPassword
    }

    const handleRecoverPasswordChange = (fieldName, value) => {
        setNewPassword((prevState) => ({
            ...prevState,
            [fieldName]: value,
        }))
    }

    const handleStartPWDReset = () => {
        // Validate email before making API call
        if (!validateEmail()) {
            return
        }

        initiateForgotPassword({
            username: email,
        })
            .then(() => {
                toast.success(
                    `Please check your ${email} email for a reset code. Make sure to check your spam folder if you don't see the email in a few minutes.`
                )
                setRecoverPasswordStep(1)
            })
            .catch((error) => {
                toast.error(error.message)
                console.log('password reset error: ', error)
            })
    }

    const handleFinishPWDReset = () => {
        if (!checkEqualPasswords()) {
            toast.error('Passwords do not match')
            return
        }
        submitNewPassword({
            username: email,
            code: newPassword.code,
            new_password: newPassword.password,
        })
            .then(() => {
                toast.success(
                    `Your password for ${email} has been reset! Please log in with your new password`
                )
                setEmail('')
                setNewPassword({
                    username: '',
                    code: '',
                    password: '',
                })
                backToLogin()
            })
            .catch((error) => {
                toast.error(error.message)
                console.log('password reset error: ', error)
            })
    }

    return {
        email,
        emailError,
        newPassword,
        checkEqualPasswords,
        handleEmailChange,
        handleRecoverPasswordChange,
        handleStartPWDReset,
        handleFinishPWDReset,
    }
}
